import script from "./payment-report-table.vue?vue&type=script&setup=true&lang=js"
export * from "./payment-report-table.vue?vue&type=script&setup=true&lang=js"

import "./payment-report-table.vue?vue&type=style&index=0&id=42ceef9b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42ceef9b"]])

export default __exports__